<script setup>
import { reactive } from 'vue';
import IconExpandCircleDown from '@/Components/Icons/IconExpandCircleDown.vue';

const props = defineProps({
  expandable: {
    type: Boolean,
    default: true
  },
  expanded: Boolean
});

const state = reactive({
  isExpanded: props.expanded
});
</script>

<template>
  <div>
    <div
      :class="{ 'cursor-pointer': expandable }"
      class="bg-code text-code-content hover:text-primary-200 rounded px-6 py-4 text-sm text-pretty transition duration-300 md:px-8"
      @click="expandable ? (state.isExpanded = !state.isExpanded) : false"
    >
      <div class="flex items-start justify-between gap-3">
        <IconExpandCircleDown
          v-if="expandable"
          class="shrink-0 transform cursor-pointer transition duration-300 ease-in-out"
          :class="{ 'rotate-180': state.isExpanded }"
        />
        <div class="text-code-content flex-1 truncate pt-0.5">
          <slot :expanded="state.isExpanded" />
        </div>
      </div>
    </div>
    <div v-if="expandable && state.isExpanded">
      <slot name="expandable" />
    </div>
  </div>
</template>
